if (!customElements.get('sp-main-navigation')) {
  customElements.define('sp-main-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.viewport = this.querySelector('[data-sp-nav-viewport]');
      this.list = this.querySelector('[data-sp-nav-list]');
      this.previous = this.querySelector('[data-sp-nav-previous]');
      this.next = this.querySelector('[data-sp-nav-next]');
      if (!this.viewport || !this.list || !this.previous || !this.next) return;
      const update = () => this.update();
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', update, {...options, passive:true});
      this.viewport.addEventListener('focusin', event => {
        const link = event.target.closest('a');
        if (!link) return;
        const box = link.getBoundingClientRect();
        const view = this.viewport.getBoundingClientRect();
        if (box.left < view.left) this.viewport.scrollBy({left:box.left-view.left-4});
        else if (box.right > view.right) this.viewport.scrollBy({left:box.right-view.right+4});
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this);
      this.observer.observe(this.list);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    move(direction) {
      this.viewport.scrollBy({left:direction*Math.max(180,this.viewport.clientWidth*.7),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    update() {
      const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
      const returnedSpace = [this.previous,this.next].reduce((width,button) => width+(button.hidden?0:button.getBoundingClientRect().width+gap),0);
      const overflow = this.list.scrollWidth > this.viewport.clientWidth+returnedSpace+1;
      this.previous.hidden = !overflow;
      this.next.hidden = !overflow;
      this.previous.disabled = this.viewport.scrollLeft <= 1;
      this.next.disabled = this.viewport.scrollLeft+this.viewport.clientWidth >= this.viewport.scrollWidth-1;
    }
  });
}
